module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-wedding-lineup-tokyo-3-2c948d571702f2998fcde5da0b94326d.jpg";